import MainLayout from "layout/MainLayout";
import React from "react";
import { Outlet } from "react-router-dom";

const AccountantLayout = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default AccountantLayout;
